import React, { useCallback } from 'react';

import { Tag, TagProps } from '../../Tag';
import type { TagGroupTagProps } from '../types';

export type TagElementProps = Omit<TagGroupTagProps, 'onClick' | 'onClose'> & {
    /**
     * Индекс тэга из массива тэгов TagGroup
     */
    tagIndex: number;
    /**
     * Колбэк на клик по тэгу
     * @param index Индекс тэга из массива тэгов TagGroup
     */
    onTagClick: (index: number) => void;
    /**
     * Колбэк на удаление тэга
     * @param tagProps Свойства комапонента Tag
     * @param index Индекс тэга из массива тэгов TagGroup
     */
    onTagClose: (tagProps: TagProps, index: number) => void;
    /**
     * Флаг, указывающий на возможность редактирования тэга
     */
    isEditable?: boolean;
};

export const TagElement = React.memo(function TagElement(props: TagElementProps) {
    const { isEditable, isReadonly, tagIndex, onTagClick, onTagClose, ...tagProps } = props;
    const onClick = useCallback(() => {
        onTagClick(tagIndex);
    }, [tagIndex, onTagClick]);
    const onClose = useCallback(() => {
        onTagClose(tagProps, tagIndex);
    }, [onTagClose, tagProps, tagIndex]);

    return <Tag {...tagProps} onClick={!isReadonly && isEditable ? onClick : undefined} onClose={onClose} />;
});
